const state = {
    reportType: '',
    detailDate: '',
    // api 조회 값을 위한 값
    filterOption: {
        fromAt: '',
        toAt: '',
    },
    // 검색을 위한 값 (filter구조 미사용)
    keyword: '',
    orderMetricsDailyConditionType: '',
    hubDailyReport: null,
};
export default state;
